module.exports = __webpack_public_path__ + "img/centennial-tic-resilience-quote3.409ebec0.svg";